import { createSlice } from '@reduxjs/toolkit';
import { createWhatsappLogin } from './api';
import { initialState } from './api/interface';

const whatsappLoginSlice = createSlice({
  name: 'whatsappLogin',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createWhatsappLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createWhatsappLogin.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createWhatsappLogin.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });

  },
});

export const { reset } = whatsappLoginSlice.actions;
export default whatsappLoginSlice.reducer;